import AppModal from "@/components/AppModal";
import AppTextField from "@/components/AppTextField";
import AppLoadingButton from "@/components/mui/LoadingButton";
import { Box } from "@mui/material";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Security2FA from "./Security2FA";
import useToggle from "@/hook/useToggle";
import { dispatch } from "@/redux/store";
import { getTaskId, getUserInfo, setTaskRuleParams } from "@/redux/slices/user";
import axiosInstance from "@/utils/axios";
import API from "@/constant/API";
import { VerifyAction } from "@/constant/VerifyConstant";
import PinInput from "@/components/PinInput.tsx";
import classes from "@/pages/security/css/index.module.less";
import SimpleHeader from "../components/Headers/SimpleHeader";
import {enqueueSnackbar} from "notistack";
import { useConfirm } from "material-ui-confirm";

function SecurityPIN() {
  const { t } = useTranslation();
  const { user } = useSelector(state => state.user);
  const [pin, setPin] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const confirm = useConfirm();
  const {
    toggle: show2FA,
    onToggle: onToggleShow2FA,
  } = useToggle(false);

  const _getTitle = () => {
    return _isPinSet() ? t('modify_pin') : t('set_pin');
  }

  const _isPinSet = () => {
    return user.pinset == 1;
  }

  const handleSubmit = async (evt) => {
    if(!pin) return;
    evt.preventDefault();

    if (!_isPinSet()) {
      _doSubmit();
      return;
    }

    confirm({
      title: t('warning'),
      description: t('security_option_change_alert_prompt'),
      confirmationText: t('confirm'),
      cancellationText: t('cancel'),
    }).then(() => {
      _doSubmit();
    });
  }

  const _doSubmit = () => {
    setTaskRuleParams({
      // action: _isPinSet() ? VerifyAction.PIN_CODE_UPDATE : VerifyAction.PIN_CODE_SET,
      action: VerifyAction.PIN_CODE_SET,
    });
    onToggleShow2FA();
  }

  const _on2FAAllPass = async () => {
    setLoading(true);
    if (!_isPinSet()) {
      try {
        const params = {
          taskId: getTaskId(),
          pinCode: pin,
        }
        await axiosInstance.post(API.SET_PIN, params);
        
        dispatch(getUserInfo());
        navigate(-1);
      } finally {
        setLoading(false);
      }
    } else {
      try {
        const params = {
          taskId: getTaskId(),
          pinCode: pin,
        }
        await axiosInstance.post(API.SET_PIN, params);
        enqueueSnackbar(t('successful'), { variant: 'success' })
        dispatch(getUserInfo());
        navigate(-1);
      } finally {
        setLoading(false);
      }
    }
  }

  if (!user) return null;

  return (<>
    <SimpleHeader />
    <Box className={classes["security-wrap"]}>
      <Box className={classes["security-title-wrap"]}>
        <div className={classes["security-title"]}>{_getTitle()}</div>
        <div className={classes["security-subtitle"]}>{t('pin_subtitle')}</div>
      </Box>
      <form autoComplete="off" onSubmit={handleSubmit}>
        <PinInput
          separator={null}
          length={6}
          value={pin}
          onChange={setPin}
        />
        {/*<AppTextField*/}
        {/*  placeholder={t('pin')}*/}
        {/*  onChange={(e) => setPin(e.target.value.trim())}*/}
        {/*  required*/}
        {/*  value={pin}*/}
        {/*  type='pin'*/}
        {/*  fullWidth*/}
        {/*  clearable*/}
        {/*  onClear={() => setPin('')}*/}
        {/*/>*/}
      </form>
      <Box className={classes["fixed-button"]}>
        <AppLoadingButton
          fullWidth
          loading={loading}
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          onClick={handleSubmit}
        >
          {t('confirm')}
        </AppLoadingButton>
      </Box>
      <AppModal open={show2FA} onClose={onToggleShow2FA}>
        <Security2FA callback={_on2FAAllPass} onClose={onToggleShow2FA}/>
      </AppModal> 
    </Box>
  </>);
}

export default SecurityPIN;
